"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATA_ORIENT = void 0;
exports.indexToRotation = indexToRotation;
exports.rotationToIndex = rotationToIndex;
var DATA_ORIENT = exports.DATA_ORIENT = Object.freeze({
  DATA_ORIENT_NO_CHANGE: 0,
  // no orientation corrections are applied to the image
  DATA_ORIENT_ROTATE_90CW: 1,
  // data frame should be rotated 90 degrees clockwise
  DATA_ORIENT_ROTATE_90CCW: 2,
  // data frame should be rotated 90 degrees counter-clockwise
  DATA_ORIENT_ROTATE_180: 3,
  // data frame should be rotated 180 degrees
  DATA_ORIENT_FLIP_VERT_ROTATE_90CW: 4,
  // data frame should be flipped in the vertical direction, THEN rotated 90 degrees clockwise
  DATA_ORIENT_FLIP_VERT_ROTATE_90CCW: 5,
  // data frame should be flipped in the vertical direction, THEN rotated 90 degrees counter-clockwise
  DATA_ORIENT_FLIP_VERT_ROTATE_180: 6,
  // data frame should be flipped in the vertical direction, THEN rotated 180 degrees
  DATA_ORIENT_FLIP_HORZ_ROTATE_90CW: 7,
  // data frame should be flipped in the vertical direction, THEN rotated 90 degrees clockwise
  DATA_ORIENT_FLIP_HORZ_ROTATE_90CCW: 8,
  // data frame should be flipped in the vertical direction, THEN rotated 90 degrees counter-clockwise
  DATA_ORIENT_FLIP_HORZ_ROTATE_180: 9 // data frame should be flipped in the vertical direction, THEN rotated 180 degrees
});

function indexToRotation(index) {
  var rotationIndices = [0, 90, 270, 180];
  if (index >= 0 && index < rotationIndices.length) {
    return rotationIndices[index];
  } else {
    return 0;
  }
}
function rotationToIndex(degree) {
  var normalDeg = (360 + degree) % 360;
  var rotationKeys = {
    0: DATA_ORIENT.DATA_ORIENT_NO_CHANGE,
    90: DATA_ORIENT.DATA_ORIENT_ROTATE_90CW,
    180: DATA_ORIENT.DATA_ORIENT_ROTATE_180,
    270: DATA_ORIENT.DATA_ORIENT_ROTATE_90CCW,
    default: DATA_ORIENT.DATA_ORIENT_NO_CHANGE
  };
  return rotationKeys[normalDeg] || DATA_ORIENT.DATA_ORIENT_NO_CHANGE;
}

// const orientation = {
//   indexToRotation,
//   rotationToIndex,
// };

// export default orientation;